import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { rawDataSummary } from "@/api/dataAll/rawData";
import * as echarts from "echarts";
export default {
  name: "rawData",
  mixins: [tabulation],
  data: function data() {
    return {
      more: true,
      value2: [],
      searchData: {
        start_time: "",
        end_time: ""
      },
      tableData: [],
      cyclicData: [],
      dates: [],
      datas: [],
      series: [],
      DynamicList: [],
      DynamicListVND: [{
        label: this.$t('date'),
        prop: 'date'
      }, {
        label: this.$t('registerCount'),
        prop: 'register_count'
      }, {
        label: this.$t('loginCount'),
        prop: 'login_count'
      }, {
        label: this.$t('rechargeCount'),
        prop: 'recharge_count'
      }, {
        label: this.$t('rechargeAmountNew'),
        prop: 'recharge_amount'
      }, {
        label: this.$t('currencyAmountUsd'),
        prop: 'recharge_amountexchange'
      }],
      DynamicListUSD: [{
        label: this.$t('date'),
        prop: 'date'
      }, {
        label: this.$t('registerCount'),
        prop: 'register_count'
      }, {
        label: this.$t('loginCount'),
        prop: 'login_count'
      }, {
        label: this.$t('rechargeCount'),
        prop: 'recharge_count'
      }, {
        label: this.$t('rechargeAmountNew'),
        prop: 'recharge_amount'
      }, {
        label: this.$t('currencyAmountVnd'),
        prop: 'recharge_amountexchange'
      }],
      DynamicListP: [{
        label: this.$t('date'),
        prop: 'date'
      }, {
        label: this.$t('registerCount'),
        prop: 'register_count'
      }, {
        label: this.$t('loginCount'),
        prop: 'login_count'
      }, {
        label: this.$t('rechargeCount'),
        prop: 'recharge_count'
      }, {
        label: this.$t('rechargeAmountNew'),
        prop: 'recharge_amount'
      }]
    };
  },
  created: function created() {},
  methods: {
    searchClickNs: function searchClickNs() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.searchClickPoints(rawDataSummary, 1);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchClick: function searchClick(lists) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var qres, res, k;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // if(this.currencyClose && !this.searchData.currency_info){
                //   this.$message.error('请选择货币类型')
                //   return
                // }
                qres = JSON.parse(JSON.stringify(lists));
                res = {
                  data: {}
                };
                qres.forEach(function (i) {
                  res.data[i.searchdate.starttime] = i[i.searchdate.starttime];
                });
                _this2.DynamicList = [];
                _context2.next = 6;
                return _this2.getexchangeRate();

              case 6:
                if (_this2.queryCurrency == 'VND') {
                  _this2.DynamicList = _this2.DynamicListVND;
                } else if (_this2.queryCurrency == 'USD') {
                  _this2.DynamicList = _this2.DynamicListP;
                } else {
                  _this2.DynamicList = _this2.DynamicListP;
                }

                _this2.tableData = [];

                for (k in res.data) {
                  _this2.tableData.push(_objectSpread(_objectSpread({
                    date: k
                  }, res.data[k]), {}, {
                    recharge_amountexchange: _this2.isyjfmvnd() ? (res.data[k]['recharge_amount'] * _this2.exchangeRate).toFixed(2) : _this2.$utils.conversion(res.data[k]['recharge_amount'] * _this2.exchangeRate).toFixed(2),
                    recharge_amount: _this2.isyjfmvnd() ? res.data[k]['recharge_amount'].toFixed(2) : _this2.$utils.conversion(res.data[k]['recharge_amount']).toFixed(2)
                  }));
                }

                _this2.$nextTick(function () {
                  _this2.getTableRight();
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.page = val;
      this.searchClick();
    },
    exportdata: function exportdata() {
      var columns = _toConsumableArray(this.DynamicList);

      this.$export.excel({
        columns: columns,
        data: this.tableData,
        title: this.$route.meta.title
      });
    }
  }
};